import { AppMessageDialog } from '../AppMessageDialog';
import { AppMessageDialogItem } from '../AppMessageDialogItem';
import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledDialogsListContainer,
	StyledLeftContainer,
	StyledLeftContainerTitle,
} from './AppMessageDialogsTab.styled';

const AppMessageDialogsTab = () => {
	return (
		<StyledContainer>
			<StyledLeftContainer>
				<StyledLeftContainerTitle>
					<TextLabel>Сообщения</TextLabel>
				</StyledLeftContainerTitle>
				<StyledDialogsListContainer>
					<AppMessageDialogItem
						name={'stdian'}
						online
						active
						time={'12:22'}
						unread
					/>
					{new Array(15).fill(0).map((_, i) => (
						<AppMessageDialogItem
							name={'stdian'}
							online={i % 2 === 0}
							active={false}
							time={'12:22'}
							unread={i % 3 === 0}
							key={i}
						/>
					))}
				</StyledDialogsListContainer>
			</StyledLeftContainer>
			<AppMessageDialog />
			{/* <StyledNotSelectedDialogContainer> */}
			{/* 	<TextLabel>Выберите один из диалогов, чтобы начать общение</TextLabel> */}
			{/* </StyledNotSelectedDialogContainer> */}
		</StyledContainer>
	);
};

export { AppMessageDialogsTab };
